import AuthRoute from './AuthRoute';
import Field from '@rezdy/components/Form/Field';
import React from 'react';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import queryString from 'query-string';
import { getRecaptcha } from '../services/recaptcha';
import { withTranslation } from 'react-i18next';

class ForgotPassword extends AuthRoute {
    componentDidMount() {
        getRecaptcha().render();
    }

    renderBody = () => {
        const { context, i18n } = this.props;
        const params = queryString.parse(window.location.search);
        const username = decodeURIComponent((params.username as string) || '');

        return (
            <div>
                <React.Fragment>
                    <Field label={i18n.t('username', { context })} name="username">
                        <TextInput type="email" defaultValue={username} />
                    </Field>
                </React.Fragment>
            </div>
        );
    };
}

export default withTranslation()(ForgotPassword);
